<script lang="ts">
    import { createEventDispatcher } from 'svelte';

    export let checked: boolean = false;
    export let label: string = '';
    export let disabled: boolean = false;
    export let scale: number = 1;

    const dispatch = createEventDispatcher();

    function handleChange() {
        console.log('VisibilitySwitch, handleChange', checked);
        dispatch('change', { checked });
    }

    function handleClick(e) {
        console.log('VisibilitySwitch, handleClick', checked);
        if (e.shiftKey) {
            if (!checked) {
                checked = true;
                handleChange();
            }
            dispatch('click', { event: e });
        }
    }

    $: {
        console.log('VisibilitySwitch, checked', checked);
    }
</script>

<label style="display:flex; align-items: center; cursor:pointer; column-gap: 6px;" class:disabled on:click={handleClick}>
    <div class="switch">
        <input type="checkbox" bind:checked on:change={handleChange} {disabled} />
        <span class="eye" class:checked style="transform: scale({scale});"/>
    </div>
    {#if label}
        <div>{@html label}</div>
    {/if}
</label>

<style>
    .disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 35px;
        min-width: 35px;
        height: 19px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .eye {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: center/75% no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13.778' height='11.905' viewBox='0 0 13.778 11.905'%3E%3Cpath d='M8.392,7.006a3.134,3.134,0,0,1,3.133,3.133,3.041,3.041,0,0,1-.226,1.147l1.83,1.83a7.4,7.4,0,0,0,2.149-2.976,7.41,7.41,0,0,0-6.892-4.7,7.3,7.3,0,0,0-2.494.439L7.246,7.232A3.041,3.041,0,0,1,8.392,7.006ZM2.127,5.3,3.555,6.724l.288.288A7.4,7.4,0,0,0,1.5,10.139a7.407,7.407,0,0,0,9.637,4.173l.263.263,1.836,1.83.8-.8L2.922,4.5ZM5.592,8.761l.971.971a1.768,1.768,0,0,0-.05.407,1.877,1.877,0,0,0,1.88,1.88,1.768,1.768,0,0,0,.407-.05l.971.971A3.112,3.112,0,0,1,5.592,8.761Zm2.7-.489,1.974,1.974.013-.1A1.877,1.877,0,0,0,8.4,8.266l-.107.006Z' transform='translate(-1.5 -4.5)' /%3E%3C/svg%3E");
    }

    .eye.checked {
        background: center/80% no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13.778' height='9.394' viewBox='0 0 13.778 9.394'%3E%3Cpath d='M8.389,6.75a7.407,7.407,0,0,0-6.889,4.7,7.4,7.4,0,0,0,13.778,0A7.407,7.407,0,0,0,8.389,6.75Zm0,7.829a3.131,3.131,0,1,1,3.131-3.131A3.133,3.133,0,0,1,8.389,14.579Zm0-5.01a1.879,1.879,0,1,0,1.879,1.879A1.876,1.876,0,0,0,8.389,9.568Z' transform='translate(-1.5 -6.75)' /%3E%3C/svg%3E");
    }

</style>
